import { render, staticRenderFns } from "./importData.vue?vue&type=template&id=6aff056c&scoped=true"
import script from "./importData.vue?vue&type=script&lang=js"
export * from "./importData.vue?vue&type=script&lang=js"
import style0 from "./importData.vue?vue&type=style&index=0&id=6aff056c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aff056c",
  null
  
)

export default component.exports